<template>
  <div id="app">
    <Header @menuActiveUpdate="updateMenu" :back="backMenu" />
    <router-view :class="{'page': true, 'page--blur': blur}" />
  </div>
</template>

<script>
import BackMenuBus from '@/services/BackMenuBus'

import Header from '@/components/AppHeader'

export default {
  name: 'App',
  components: {
    Header
  },
  data() {
    return {
      blur: false,
      backMenu: false
    }
  },
  methods: {
    updateMenu(state) {
      this.blur = state
    }
  },
  mounted() {
    BackMenuBus.$on('showBackMenu', backMenuState => {
      this.backMenu = backMenuState
    })
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'mg-sm';
  src: url('./assets/fonts/MonumentGrotesk-Semi-Mono.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}
html {
  background-color:#f6f5f4;
}
#app {
  display: inline-block;
  width:100%;
  min-height:100vh;
  background-color:#f6f5f4;
  &.grey {
    background-color: #c3c3c3;
  }
  .page {
    transition:filter 400ms ease-in-out;
    transform:translateZ(0);
    transform-style:preserve-3d;
    filter:blur(0px);
    &--blur {
      filter:blur(18px);
    }
  }
  @media screen and (max-width: 768px) {
    min-height:100%;
  }
}
</style>
